import { createUseStyles } from "react-jss";

export const RequestListContainerStyle = createUseStyles((theme: any) => ({
    list: {
        backgroundColor: "var( --color-white)",
        display:"flex",
        flexDirection:"column", 
        alignItems:"center"
    },
    headerHistory: {
        backgroundColor: "var(--background-header-color)",
        width: "100vw",
       
        marginTop: "-15px",
        marginLeft: "-15px",

        padding: "var(--gaps-sizes-sm)",
        fontWeight: "var(--font-weigth-bold)",
        display: "flex",
        flex: "1 1 auto",
    },  
}));
